import { Routes } from '@angular/router';
import { CorporateTravelComponent } from './corporate-travel.component';

export default [
    {
        path     : '',
        component: CorporateTravelComponent,
    },
    
] as Routes;
